import manufacture from '../assets/new-ui/economy/manufacture.png'
import crop from '../assets/new-ui/economy/crop.png'
import mine from '../assets/new-ui/economy/mine.png'
import breeding from '../assets/new-ui/economy/breeding.png'
import products from '../assets/new-ui/economy/products.png'
import resources from '../assets/new-ui/economy/resources.png'
import meat from '../assets/new-ui/economy/meat.png'
import upgrade from '../assets/new-ui/economy/upgrade.png'
import war from '../assets/new-ui/economy/war.png'
import bank from '../assets/new-ui/economy/bank.png'
import commerce from '../assets/new-ui/economy/commerce.png'
import reinvest from '../assets/new-ui/economy/reinvest.png'
import gdc from '../assets/new-ui/economy/GDC.png'
import gdcBNB from '../assets/new-ui/economy/gdc-bnb.png'
import shark from '../assets/new-ui/economy/shark.png'
import land from '../assets/new-ui/economy/land.png'
import combine from '../assets/new-ui/economy/combine.png'
import profit from '../assets/new-ui/economy/profit.png'

// import manufactureMobile from '../assets/new-ui/economy/manufacture-mobile.png'
// import cropMobile from '../assets/new-ui/economy/crop-mobile.png'
// import mineMobile from '../assets/new-ui/economy/mine-mobile.png'
// import breedingMobile from '../assets/new-ui/economy/breeding-mobile.png'
// import productsMobile from '../assets/new-ui/economy/products-mobile.png'
// import resourcesMobile from '../assets/new-ui/economy/resources-mobile.png'
// import meatMobile from '../assets/new-ui/economy/meat-mobile.png'
// import upgradeMobile from '../assets/new-ui/economy/upgrade-mobile.png'
// import warMobile from '../assets/new-ui/economy/war-mobile.png'
// import bankMobile from '../assets/new-ui/economy/bank-mobile.png'
// import commerceMobile from '../assets/new-ui/economy/commerce-mobile.png'
// import reinvestMobile from '../assets/new-ui/economy/reinvest-mobile.png'
// import gdcMobile from '../assets/new-ui/economy/GDC-mobile.png'
// import gdcBNBMobile from '../assets/new-ui/economy/gdc-bnb-mobile.png'
// import sharkMobile from '../assets/new-ui/economy/shark-mobile.png'
// import landMobile from '../assets/new-ui/economy/land-mobile.png'
// import combineMobile from '../assets/new-ui/economy/combine-mobile.png'
// import profitMobile from '../assets/new-ui/economy/profit-mobile.png'

import manufactureMobile from '../assets/new-ui/economy/manufacture.png'
import cropMobile from '../assets/new-ui/economy/crop.png'
import mineMobile from '../assets/new-ui/economy/mine.png'
import breedingMobile from '../assets/new-ui/economy/breeding.png'
import productsMobile from '../assets/new-ui/economy/products.png'
import resourcesMobile from '../assets/new-ui/economy/resources.png'
import meatMobile from '../assets/new-ui/economy/meat.png'
import upgradeMobile from '../assets/new-ui/economy/upgrade.png'
import warMobile from '../assets/new-ui/economy/war.png'
import bankMobile from '../assets/new-ui/economy/bank.png'
import commerceMobile from '../assets/new-ui/economy/commerce.png'
import reinvestMobile from '../assets/new-ui/economy/reinvest.png'
import gdcMobile from '../assets/new-ui/economy/GDC.png'
import gdcBNBMobile from '../assets/new-ui/economy/gdc-bnb.png'
import sharkMobile from '../assets/new-ui/economy/shark.png'
import landMobile from '../assets/new-ui/economy/land.png'
import combineMobile from '../assets/new-ui/economy/combine.png'
import profitMobile from '../assets/new-ui/economy/profit.png'

export const economyList = {
  manufacture: {
    img: manufacture,
    imgMobile: manufactureMobile,
    text: 'Manufacture'
  },
  crop: {
    img: crop,
    imgMobile: cropMobile,
    text: 'Crop <br/> in field'
  },
  mine: {
    img: mine,
    imgMobile: mineMobile,
    text: 'Mining <br/> in mine'
  },
  breeding: {
    img: breeding,
    imgMobile: breedingMobile,
    text: 'Breeding <br/> in shed'
  },
  products: {
    img: products,
    imgMobile: productsMobile,
    text: 'Agricultural <br/> products'
  },
  resources: {
    img: resources,
    imgMobile: resourcesMobile,
    text: 'Resouces'
  },
  meat: {
    img: meat,
    imgMobile: meatMobile,
    text: 'Meat'
  },
  upgrade: {
    img: upgrade,
    imgMobile: upgradeMobile,
    text: 'Upgrade <br/> character'
  },
  war: {
    img: war,
    imgMobile: warMobile,
    text: 'Holywar <br/> (PvE, PvP, Tournament, Ranking, World Boss)'
  },
  bank: {
    img: bank,
    imgMobile: bankMobile,
    text: 'Bank'
  },
  commerce: {
    img: commerce,
    imgMobile: commerceMobile,
    text: 'Commerce'
  },
  reinvest: {
    img: reinvest,
    imgMobile: reinvestMobile,
    text: 'Reinvest'
  },
  gdc: {
    img: gdc,
    imgMobile: gdcMobile,
    text: 'GDC'
  },
  gdcBNB: {
    img: gdcBNB,
    imgMobile: gdcBNBMobile,
    text: 'GDC/BNB'
  },
  shark: {
    img: shark,
    imgMobile: sharkMobile,
    text: 'NFT Shark'
  },
  land: {
    img: land,
    imgMobile: landMobile,
    text: 'Holly Lands'
  },
  combine: {
    img: combine,
    imgMobile: combineMobile,
    text: 'Combine'
  },
  profit: {
    img: profit,
    imgMobile: profitMobile,
    text: 'Take Profit'
  },
}